export default "__VITE_ASSET__B4HTK1is__"